(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["boutique-rail"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.boutique-rail').forEach(function (section) {
    var rail = section.querySelector('[data-rail]');
    var nav = section.querySelector('.merch__nav');
    if (!rail) return;
    var arrows = section.querySelectorAll('.merch__nav .arrow');

    function step() {
      var card = rail.querySelector('.card__prod');
      var gap = parseFloat(getComputedStyle(rail).gap) || 20;
      return card ? card.offsetWidth + gap : 300;
    }

    arrows.forEach(function (btn) {
      btn.addEventListener('click', function () {
        rail.scrollBy({ left: step() * parseInt(btn.dataset.dir, 10), behavior: 'smooth' });
      });
    });

    function update() {
      var max = rail.scrollWidth - rail.clientWidth - 2;
      if (nav) nav.style.display = max <= 0 ? 'none' : '';
      if (arrows.length < 2) return;
      arrows[0].disabled = rail.scrollLeft <= 2;
      arrows[1].disabled = rail.scrollLeft >= max;
    }

    rail.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["epicerie"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.epicerie [data-count]').forEach(function (el) {
    var target = parseInt(el.dataset.count, 10);
    if (isNaN(target)) return; // valeur non numérique : on laisse le texte tel quel

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) {
      el.textContent = target;
      return;
    }

    // Remise à zéro hors écran pour éviter tout saut visible à l'arrivée.
    el.textContent = '0';

    function run() {
      var n = 0;
      (function step() {
        n += Math.max(1, Math.round((target - n) / 9));
        if (n >= target) { el.textContent = target; return; }
        el.textContent = n;
        requestAnimationFrame(step);
      })();
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        run();
        io.unobserve(entry.target);
      });
    }, { threshold: 0.4 });
    io.observe(el);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var nav = document.querySelector('[data-nav]');
    if (!nav) return;
    var burger = nav.querySelector('.burger');
    var panel = document.getElementById('rebelle-menu');
    var closeBtn = panel ? panel.querySelector('.menu__close') : null;

    function toggleMenu(open) {
      if (!panel) return;
      panel.classList.toggle('on', open);
      panel.setAttribute('aria-hidden', open ? 'false' : 'true');
      if (burger) burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.style.overflow = open ? 'hidden' : '';
      var target = open ? closeBtn : burger;
      if (target) target.focus();
    }

    if (burger) burger.addEventListener('click', function () { toggleMenu(true); });
    if (closeBtn) closeBtn.addEventListener('click', function () { toggleMenu(false); });
    if (panel) {
      panel.querySelectorAll('a').forEach(function (a) {
        a.addEventListener('click', function () { toggleMenu(false); });
      });
    }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && panel && panel.classList.contains('on')) toggleMenu(false);
    });

    // Barre opaque une fois le hero dépassé (mode overlay seulement).
    if (nav.hasAttribute('data-overlay')) {
      var hero = document.querySelector('.hero');
      if (hero && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          nav.classList.toggle('stuck', !entries[0].isIntersecting);
        }, { rootMargin: '-120px 0px 0px 0px' }).observe(hero);
      } else {
        nav.classList.add('stuck');
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-saveurs"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.hero-saveurs').forEach(function (hero) {
    var shots = hero.querySelectorAll('.stage img');
    var picks = hero.querySelectorAll('.picker button');
    if (!shots.length || !picks.length) return;

    // L'ordre de rotation suit l'ordre des pastilles rendues (champ « ordre »).
    var ORDER = Array.prototype.map.call(picks, function (b) { return b.dataset.f; });
    var calm = matchMedia('(prefers-reduced-motion: reduce)').matches;

    function show(key) {
      shots.forEach(function (i) { i.classList.toggle('is-on', i.dataset.f === key); });
      picks.forEach(function (b) {
        b.setAttribute('aria-selected', b.dataset.f === key ? 'true' : 'false');
      });
    }

    var timer = null;
    function stop() { clearInterval(timer); }
    function play() {
      if (calm) return;
      stop();
      timer = setInterval(function () {
        var sel = hero.querySelector('.picker [aria-selected="true"]');
        var cur = sel ? sel.dataset.f : ORDER[0];
        show(ORDER[(ORDER.indexOf(cur) + 1) % ORDER.length]);
      }, 3600);
    }

    // La rotation ne s'arrête qu'au choix explicite d'une saveur.
    picks.forEach(function (b) {
      b.addEventListener('click', function () { show(b.dataset.f); stop(); });
    });

    show(ORDER[0]);
    play();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["menu-cremerie"]) return;
  try {
    
  (function () {
    var loupe = document.querySelector('[data-loupe]');
    if (!loupe) return;
    var img = loupe.querySelector('[data-loupe-img]');
    var closeBtn = loupe.querySelector('[data-loupe-close]');
    var trigger = null;

    function open(btn) {
      var thumb = btn.querySelector('img');
      if (!thumb) return;
      trigger = btn;
      img.src = thumb.getAttribute('data-full') || thumb.src;
      img.alt = thumb.alt || '';
      loupe.classList.add('on');
      loupe.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      closeBtn.focus();
    }

    function close() {
      loupe.classList.remove('on');
      loupe.setAttribute('aria-hidden', 'true');
      img.src = '';
      document.body.style.overflow = '';
      if (trigger) { trigger.focus(); trigger = null; }
    }

    document.querySelectorAll('[data-zoom]').forEach(function (b) {
      b.addEventListener('click', function () { open(b); });
    });
    closeBtn.addEventListener('click', close);
    loupe.addEventListener('click', function (e) { if (e.target === loupe) close(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && loupe.classList.contains('on')) close();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nous-joindre"]) return;
  try {
    
  (function () {
    var ok = document.getElementById('contact-ok');
    if (!ok) return;
    ok.scrollIntoView({ behavior: 'smooth', block: 'center' });
    if (typeof ok.focus === 'function') ok.focus();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ou-acheter"]) return;
  try {
    
  (function () {
    /* Liste des épiceries : recherche texte + filtre province (amélioration
       progressive : sans JS, le tableau complet reste affiché). */
    document.querySelectorAll('.ou-acheter [data-pdv-table]').forEach(function (table) {
      var root = table.closest('.oa-liste');
      var outils = root.querySelector('[data-pdv-outils]');
      var input = root.querySelector('[data-pdv-q]');
      var vide = root.querySelector('[data-pdv-vide]');
      var btns = root.querySelectorAll('[data-pdv-p]');
      var prov = '';
      outils.hidden = false;
      function norm(t) { return (t || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ''); }
      function apply() {
        var q = norm(input.value.trim());
        var total = 0;
        table.querySelectorAll('[data-pdv-groupe]').forEach(function (g) {
          var shown = 0;
          var okProv = !prov || g.dataset.p === prov;
          g.querySelectorAll('tr[data-q]').forEach(function (tr) {
            var ok = okProv && (!q || norm(tr.dataset.q).indexOf(q) !== -1);
            tr.hidden = !ok;
            if (ok) shown++;
          });
          g.hidden = shown === 0;
          total += shown;
        });
        vide.hidden = total !== 0;
      }
      input.addEventListener('input', apply);
      btns.forEach(function (b) {
        b.addEventListener('click', function () {
          prov = b.dataset.pdvP;
          btns.forEach(function (x) {
            var on = x === b;
            x.classList.toggle('is-active', on);
            x.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          apply();
        });
      });
    });
  })();

  (function () {
    /* Compteur : monte de 0 à la cible à l'entrée dans le viewport.
       Coupé sous prefers-reduced-motion (affiche directement la cible). */
    document.querySelectorAll('.ou-acheter [data-count]').forEach(function (el) {
      var target = parseInt(el.dataset.count, 10);
      if (isNaN(target)) return;

      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce || !('IntersectionObserver' in window)) {
        el.textContent = target;
        return;
      }

      el.textContent = '0';
      function run() {
        var n = 0;
        (function step() {
          n += Math.max(1, Math.round((target - n) / 9));
          if (n >= target) { el.textContent = target; return; }
          el.textContent = n;
          requestAnimationFrame(step);
        })();
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          run();
          io.unobserve(entry.target);
        });
      }, { threshold: 0.4 });
      io.observe(el);
    });

    /* Hauteur de l'iframe pilotée par le CRM (postMessage).
       Origine validée strictement contre le domaine configuré ;
       valeur numérique bornée entre 200 et 4000 px. */
    var frame = document.querySelector('.ou-acheter [data-map-frame]');
    if (frame) {
      var origin = frame.getAttribute('data-crm-origin');
      window.addEventListener('message', function (e) {
        if (!origin || e.origin !== origin) return;
        var h = e.data && e.data.hauteur;
        if (typeof h !== 'number' || !isFinite(h)) return;
        h = Math.max(200, Math.min(4000, h));
        frame.style.height = h + 'px';
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["politique"]) return;
  try {
    
  (function () {
    var grid = document.querySelector('.politique [data-legal]');
    if (!grid) return;
    var body = grid.querySelector('[data-body]');
    var toc = grid.querySelector('[data-toc]');
    var list = grid.querySelector('[data-toc-list]');
    if (!body || !toc || !list) return;

    var heads = [].slice.call(body.querySelectorAll('h2'));
    /* Moins de 3 titres : pas de sommaire, le texte reste pleine largeur. */
    if (heads.length < 3) return;

    function slug(txt) {
      var s = (txt || '').toLowerCase();
      if (s.normalize) s = s.normalize('NFD').replace(/[̀-ͯ]/g, '');
      s = s.replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
      return s || 'section';
    }

    var used = {};
    var entries = heads.map(function (h) {
      var id = h.id;
      if (!id) {
        var base = slug(h.textContent);
        id = base;
        var i = 2;
        while (used[id] || (document.getElementById(id) && document.getElementById(id) !== h)) {
          id = base + '-' + i;
          i++;
        }
        h.id = id;
      }
      used[id] = true;
      return { h: h, id: id, text: h.textContent };
    });

    var links = {};
    var frag = document.createDocumentFragment();
    entries.forEach(function (e) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + e.id;
      a.textContent = e.text;
      li.appendChild(a);
      frag.appendChild(li);
      links[e.id] = a;
    });
    list.appendChild(frag);
    toc.hidden = false;
    grid.classList.add('is-toc');

    /* Scroll-spy : surligne la section en cours de lecture. */
    if (!('IntersectionObserver' in window)) return;
    var obs = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        Object.keys(links).forEach(function (k) { links[k].classList.remove('actif'); });
        var a = links[e.target.id];
        if (a) a.classList.add('actif');
      });
    }, { rootMargin: '-88px 0px -70% 0px' });
    entries.forEach(function (e) { obs.observe(e.h); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-popup"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const KEY = 'rebelle-promo-';
    const seenRecently = (campaign, days) => {
      try {
        const last = Number(localStorage.getItem(KEY + campaign) || 0);
        return last && Date.now() - last < days * 86400000;
      } catch (e) { return false; }
    };
    const remember = (campaign) => {
      try { localStorage.setItem(KEY + campaign, String(Date.now())); } catch (e) {}
    };

    const init = (pop, force) => {
      if (!pop || pop.dataset.bound) return;
      pop.dataset.bound = '1';
      const campaign = pop.dataset.campaign;
      const days = Number(pop.dataset.days || 1);
      const close = () => { remember(campaign); if (pop.open) pop.close(); };

      pop.querySelector('[data-promo-close]').addEventListener('click', close);
      pop.querySelector('[data-promo-go]').addEventListener('click', () => remember(campaign));
      pop.addEventListener('cancel', () => remember(campaign));
      pop.addEventListener('click', (e) => { if (e.target === pop) close(); });

      if (force) { pop.showModal(); return; }
      const end = Number(pop.dataset.end || 0);
      if (end) {
        const d = new Date();
        const today = d.getFullYear() * 10000 + (d.getMonth() + 1) * 100 + d.getDate();
        if (today > end) return;
      }
      if (seenRecently(campaign, days)) return;
      setTimeout(() => {
        if (!pop.open && document.visibilityState !== 'hidden') pop.showModal();
        else if (!pop.open) {
          document.addEventListener('visibilitychange', function once() {
            if (document.visibilityState === 'visible') { document.removeEventListener('visibilitychange', once); if (!pop.open) pop.showModal(); }
          });
        }
      }, Number(pop.dataset.delay || 0) * 1000);
    };

    document.querySelectorAll('[data-promo-pop]').forEach((p) => init(p, false));

    // Éditeur de thème : ouvrir quand la section est sélectionnée.
    document.addEventListener('shopify:section:load', (e) => {
      const p = e.target.querySelector('[data-promo-pop]');
      if (p) init(p, true);
    });
    document.addEventListener('shopify:section:select', (e) => {
      const p = e.target.querySelector('[data-promo-pop]');
      if (p) { init(p, true); if (!p.open) p.showModal(); }
    });
    document.addEventListener('shopify:section:deselect', (e) => {
      const p = e.target.querySelector('[data-promo-pop]');
      if (p && p.open) p.close();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["suppression-donnees"]) return;
  try {
    
  (function () {
    var grid = document.querySelector('.politique [data-legal-supp]');
    if (!grid) return;
    var body = grid.querySelector('[data-body-supp]');
    var toc = grid.querySelector('[data-toc-supp]');
    var list = grid.querySelector('[data-toc-list]');
    if (!body || !toc || !list) return;
    if (list.children.length) return; /* déjà construit */

    var heads = [].slice.call(body.querySelectorAll('h2'));
    /* Moins de 3 titres : pas de sommaire, le texte reste pleine largeur. */
    if (heads.length < 3) return;

    function slug(txt) {
      var s = (txt || '').toLowerCase();
      if (s.normalize) s = s.normalize('NFD').replace(/[̀-ͯ]/g, '');
      s = s.replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
      return s || 'section';
    }

    var used = {};
    var entries = heads.map(function (h) {
      var id = h.id;
      if (!id) {
        var base = slug(h.textContent);
        id = base;
        var i = 2;
        while (used[id] || (document.getElementById(id) && document.getElementById(id) !== h)) {
          id = base + '-' + i;
          i++;
        }
        h.id = id;
      }
      used[id] = true;
      return { h: h, id: id, text: h.textContent };
    });

    var links = {};
    var frag = document.createDocumentFragment();
    entries.forEach(function (e) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + e.id;
      a.textContent = e.text;
      li.appendChild(a);
      frag.appendChild(li);
      links[e.id] = a;
    });
    list.appendChild(frag);
    toc.hidden = false;
    grid.classList.add('is-toc');

    /* Scroll-spy : surligne la section en cours de lecture. */
    if (!('IntersectionObserver' in window)) return;
    var obs = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        Object.keys(links).forEach(function (k) { links[k].classList.remove('actif'); });
        var a = links[e.target.id];
        if (a) a.classList.add('actif');
      });
    }, { rootMargin: '-88px 0px -70% 0px' });
    entries.forEach(function (e) { obs.observe(e.h); });
  })();

  } catch(e) { console.error(e); }
})();
})();
